import { Component, OnInit } from '@angular/core';
import { PerfilCapacitacion } from 'src/app/models/perfil-cap.model';
import { CursosService } from 'src/app/services/cursos.service';
import { AuthService } from 'src/app/_helpers';
import { SortEvent } from 'primeng/api';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-capacitaciones-user',
  templateUrl: './capacitaciones-user.component.html',
  styleUrls: ['./capacitaciones-user.component.scss']
})
export class CapacitacionesUserComponent implements OnInit {
  listCapacitacion: PerfilCapacitacion[];
  // codCurso = '';
  codPersona = '';
  fecVenc: Date;
  estados:any;

  constructor(private estado: CursosService, private authService: AuthService) { }
  // 
  ngOnInit(){
    // this.estados= this.authService.getTabla('EstadoCurso');    
    this.codPersona = this.authService.getusuarioJson().codPersona;
    console.log('mis capacitaciones', this.codPersona);
    this.estado.getMisCapacitaciones(this.codPersona).subscribe(
      data => {
        this.listCapacitacion = data['data']
      }, error => {
        console.log('Error', error);
      }
    );
  }


  DescargarCertificado(perfil){
    console.log(perfil);
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', `${environment.apiCap}Capacitaciones/Participante/Certificado/` +this.codPersona+'/'+ perfil.codCurso);
    link.setAttribute('download', `certificado.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

  }

  formatoFecha(fecha: string){
    this.fecVenc = new Date(fecha);
    return moment(this.fecVenc).format('DD/MM/YYYY');
  
  }

  // getEstado(estado: number){
  //   return this.estados.filter(e=>+e.codRegistro==estado)[0].descripcion;
  // }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
            result = value1.localeCompare(value2);
        else
            result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
    });
}

}
